import React from 'react';

export const CurrentReplenishmentStock = (props) => {


        let styles = {fontWeight: 'bold', fontSize: 'medium'};

        let colorStyle = {color: 'black'};
        if (props.availableStock <= 0) {
            colorStyle = {color: 'red'};
        }

        if (props.unlimitedStock === true) {
            return (
                <span title="NOS" style={styles}>
                    NOS
                </span>
            );
        }

        return (
                <span title="Gesamt/In Bearbeitung/Verfügbar"
                      style={styles}>
                    {props.actualStock}/{props.reservedStock}/<span style={colorStyle}> {props.availableStock}</span>
                </span>
        )

}

export default CurrentReplenishmentStock;





// WEBPACK FOOTER //
// ./src/admin/components/CurrentReplenishmentStock.js